/** dataId 비교 시 문자열로 통일 (API 숫자/문자 혼용 대비) */
export function idKey(id) {
    return String(id);
}

/** 현재 목록 항목이 chkedData에 모두 포함됐는지 (전체 선택 상태) */
export function isFullListSelected(monitData, chkedData) {
    const allIdNos = (monitData ?? []).map((el) => el.dataId);
    const allKeys = new Set(allIdNos.map(idKey));
    const selectedKeys = new Set(chkedData.map(idKey));
    return (
        allKeys.size > 0 &&
        allKeys.size === selectedKeys.size &&
        [...allKeys].every((k) => selectedKeys.has(k))
    );
}
